// =============================================
// NotesEmbed — a TipTap block node for an allow-listed video embed (YouTube/Vimeo).
// =============================================
// Stores ONLY { provider, videoId } — no URL, no bytes. The NodeView rebuilds the
// iframe src from a trusted template (see embedUtils.embedSrc) and renders it in a
// sandboxed iframe, so a tampered document can never inject an arbitrary src.
// =============================================
import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import EmbedNodeView from './EmbedNodeView';

export const NotesEmbed = Node.create({
  name: 'notesEmbed',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      provider: { default: null }, // 'youtube' | 'vimeo'
      videoId: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-notes-embed]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, {
      'data-notes-embed': '',
      'data-provider': HTMLAttributes.provider,
      'data-video-id': HTMLAttributes.videoId,
    })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(EmbedNodeView);
  },
});
